'use client';

import { apiSwagger } from '@/shared/api';
import { NEXT_PROD } from '@/shared/envs';
import etaLoader from '@/shared/EtaLoader';
import { useEffect } from 'react';

// Extend Window interface to include analytics properties
declare global {
  interface Window {
    dataLayer: any[];
    ym: any;
    adsbygoogle: any[];
  }
}

export default function ServicesLoader() {
  useEffect(() => {
    // Handle geolocation, logging, and ads in one flow
    handleGeolocationAndAnalytics();
    // GTM is now injected in <head> via layout.tsx
      
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('startingUp', 0.7);
    }
  }, []);

  const handleGeolocationAndAnalytics = async () => {
    try {
      let country: string | undefined = '';

      // Log visitor with geolocation data using new backend API
      try {
        await apiSwagger.iplogging.iploggingCreate();
        const logResponse = await fetch('/api/log-visitor', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: '' 
        });
        
        if (logResponse.ok) {
          const logData = await logResponse.json();
          
          if (logData.ipInfo && logData.ipInfo.country) {
            country = logData.ipInfo.country;
            console.log('[IpLogging] Get country from response:', country);
          }
        } else {
          console.error('[IpLogging] Failed to log visitor data:', logResponse.status, logResponse.statusText);
        }
      } catch (error) {
        console.error('[IpLogging] Failed to log visitor:', error);
      }

    } catch (err) {
      throw err;
    }
    if (typeof window !== 'undefined' && etaLoader) {
      etaLoader.setStage('startingUp', 0.9);
    }
  };

  return null; // This component doesn't render anything
} 